module.exports = __webpack_public_path__ + "img/preview-lg.f686d5fc.png";